/**
 * @file Configuration of the Redux store
 */

import type { StoreEnhancer } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";
import metricsFilterSlice from "./metrics/metrics-filter-slice";
import activeAssetSlice from "./assets/active-asset-slice";
import newAssetSlice from "./map/edit-map/new-asset-slice";
import insertionDateSlice from "./inspections/insertion-date-slice";
import portSlice from "./port/port-slice";
import mapSlice from "./map/map-slice";
import customFieldsSlice from "./custom-fields/custom-fields-slice";
import * as Sentry from "@sentry/react";

const sentryReduxEnhancer = Sentry.createReduxEnhancer() as StoreEnhancer;

const reducer = {
  activeAsset: activeAssetSlice,
  newAsset: newAssetSlice,
  insertionDate: insertionDateSlice,
  map: mapSlice,
  metricsFilter: metricsFilterSlice,
  port: portSlice,
  customFields: customFieldsSlice,
};

// configureStore's return type is too generic to write by hand; AppStore is
// derived from ReturnType<typeof makeStore> below.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function makeStore() {
  return configureStore({
    reducer,
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers().concat(sentryReduxEnhancer),
  });
}

const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];

export default store;
